<template>
  <b-modal
    ref="associatedCasesListModal"
    :title="$t('component.AssociateCaseModal.associatedCases')"
    centered
    modal-class="associatedCasesListModal"
    @hide="onHide"
  >
    <div v-if="associatedCases">
      <b-row class="mx-3 pb-2 list">
        <b-col>
          {{ $tc('global.case',1) }}
        </b-col>
        <b-col cols="3">
          {{ $t('global.priority') }}
        </b-col>
        <b-col>
          {{ $tc('global.status',1) }}
        </b-col>
      </b-row>
      <b-row
        v-for="(associatedCase, index) in associatedCases"
        :key="index"
        class="mx-3 py-2 list"
      >
        <b-col class="case">
          {{ associatedCase.casCasenumber }}
        </b-col>
        <b-col
          cols="3"
          class="d-flex align-items-center"
        >
          <priority-dot
            show-label
            class="ml-2"
            :priority="associatedCase.priority"
          />
        </b-col>
        <b-col>
          <case-status-badge
            class="status-badge"
            :status="associatedCase.status"
          />
        </b-col>
      </b-row>
    </div>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import PriorityDot from '@/modules/clinicalModule/components/StatusRequestPriorityDot'
import CaseStatusBadge from '@/components/common/CommonCaseStatusBadge'
import caseServices from '@/api/resources/common/commonCaseServices'
export default {
    name: 'AssociatedCasesListModal',
    components: {
        PriorityDot,
        CaseStatusBadge
    },
    data() {
        return {
            associatedCases: []
        }
    },
    methods: {
        onHide() {
            this.associatedCases = []
        },
        async show(casId) {
            const [err, response] = await this.toCall(caseServices.getAssociatedCases(this.$store.getters.labId, casId))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.associatedCases = response
            this.$refs.associatedCasesListModal.show()
        },
        hide() {
            this.$refs.associatedCasesListModal.hide()
        }
    }
}
</script>

<style lang="scss">
.associatedCasesListModal .modal-dialog {
  max-width: 45% !important;
}
</style>

<style lang="scss" scoped>
.list{
    border-bottom: 1px solid vt-color(light-grey);
}
.case{
    color: vt-color(dark-text);
}
</style>
